import trainer_apply from '@/api/trainer_apply';

import { FETCH_TRAINER_APPLY, FETCH_COACH, SEARCH_COACH, BIND_COACH } from './types';

export default {
    [FETCH_TRAINER_APPLY]({ commit }, payload) {
        return trainer_apply
            .get(payload.id)
            .then(resp => commit(FETCH_TRAINER_APPLY, resp));
    },
    [FETCH_COACH]({ commit }, payload) {
        return trainer_apply
            .getCoach(payload.id)
            .then(resp => commit(FETCH_COACH, resp));
    },
    [SEARCH_COACH]({ commit }, payload) {
        return trainer_apply
            .search(payload.phone)
            .then(resp => commit(FETCH_COACH, resp));
    },
    [BIND_COACH]({ commit }, payload) {
        return trainer_apply
            .bind(payload.phone, payload.message)
            .then(resp => commit(FETCH_TRAINER_APPLY, resp));
    },
};



// WEBPACK FOOTER //
// ./src/store/trainer_apply/actions.js